import React from 'react';

import { FieldArray } from '~src/settings/FormikWrapperForStubbing';
import { cssClass } from '~src/style';

import { LoadingDataSpinner } from '../LoadingDataSpinner';
import { Cluster } from '../types/Cluster';
import { DataConnectSharedClusterTableEntryCluster } from './DataConnectSharedClusterTableEntryCluster';

export type DataConnectSharedClusterTableBodyProps = Readonly<{
  clusters: Record<string, Cluster>;
  hasLoadedPoolsAndClusters: boolean;
}>;

export function DataConnectSharedClusterTableBody(props: DataConnectSharedClusterTableBodyProps) {

  const clusters: ReadonlyArray<Cluster> = Object.values(props.clusters);

  if(!props.hasLoadedPoolsAndClusters) {
    return LoadingDataSpinner();
  }

  return (
    <FieldArray
      name={''}
      render={() => (
        clusters.map((cluster: Cluster, index) => (
          <tbody key={index}>
            <tr>
              <DataConnectSharedClusterTableEntryCluster
                cluster={cluster}
              />
            </tr>
          </tbody>))
      )}
    />
  );
}

const focusClass = cssClass('MultiPool', 'expanded-focus', {
  background: 'rgba(255, 255, 255, 0.00)',
});